<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';
import { EXTENSOES_ACEITAS } from './helpers';

defineProps({
  anexos: { type: Array, default: () => [] },
  recusas: { type: Array, default: () => [] },
  disabled: { type: Boolean, default: false },
});

const emit = defineEmits(['adicionar', 'remover']);

const { t } = useI18n();
const seletor = ref(null);
const arrastando = ref(false);
const aceita = EXTENSOES_ACEITAS.map(extensao => `.${extensao}`).join(',');

const tamanhoLegivel = bytes =>
  bytes < 1024 * 1024
    ? `${Math.max(1, Math.round(bytes / 1024))} KB`
    : `${(bytes / (1024 * 1024)).toFixed(1)} MB`;

const escolher = evento => {
  emit('adicionar', evento.target.files);
  evento.target.value = '';
};

const soltar = evento => {
  arrastando.value = false;
  emit('adicionar', evento.dataTransfer.files);
};
</script>

<template>
  <div class="flex flex-col gap-2">
    <span class="text-sm font-medium text-n-slate-12">
      {{ t('SUPORTE_AMSHIFT.ANEXOS.TITULO') }}
    </span>
    <button
      type="button"
      :disabled="disabled"
      class="flex flex-col items-center justify-center gap-1 px-4 py-3 text-sm border border-dashed rounded-lg text-n-slate-11 hover:bg-n-alpha-1"
      :class="arrastando ? 'border-n-blue-9 bg-n-alpha-1' : 'border-n-weak'"
      @click="seletor?.click()"
      @dragover.prevent="arrastando = true"
      @dragleave.prevent="arrastando = false"
      @drop.prevent="soltar"
    >
      <span class="flex items-center gap-2">
        <span class="i-lucide-paperclip size-4" />
        {{ t('SUPORTE_AMSHIFT.ANEXOS.SOLTAR') }}
      </span>
      <span class="text-xs text-n-slate-10">
        {{ t('SUPORTE_AMSHIFT.ANEXOS.LIMITES') }}
      </span>
    </button>
    <input
      ref="seletor"
      type="file"
      multiple
      class="hidden"
      :accept="aceita"
      @change="escolher"
    />
    <ul v-if="anexos.length" class="flex flex-col gap-1">
      <li
        v-for="(anexo, indice) in anexos"
        :key="`${anexo.name}-${indice}`"
        class="flex items-center justify-between gap-2 px-2 py-1 text-sm rounded-md bg-n-alpha-1"
      >
        <span class="truncate text-n-slate-12">{{ anexo.name }}</span>
        <span class="flex items-center gap-1 shrink-0 text-xs text-n-slate-10">
          {{ tamanhoLegivel(anexo.size) }}
          <Button
            type="button"
            icon="i-lucide-x"
            variant="ghost"
            color="slate"
            size="xs"
            :title="t('SUPORTE_AMSHIFT.ANEXOS.REMOVER', { nome: anexo.name })"
            :disabled="disabled"
            @click="emit('remover', indice)"
          />
        </span>
      </li>
    </ul>
    <p
      v-for="recusa in recusas"
      :key="`${recusa.chave}-${recusa.nome}`"
      class="mb-0 text-xs text-n-ruby-11"
    >
      {{
        t(`SUPORTE_AMSHIFT.ANEXOS.RECUSA.${recusa.chave}`, {
          nome: recusa.nome,
        })
      }}
    </p>
  </div>
</template>
